import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './CaffaExplainerPage.css';

const DIMENSIONS = ['complexity', 'accuracy', 'fluency', 'functional_adequacy'] as const;

const CaffaExplainerPage: React.FC = () => {
    const { t } = useTranslation('knowledgeGraph');

    const combos = t('caffa.explainer.combos', { returnObjects: true }) as string[];
    const tips = t('caffa.explainer.tips', { returnObjects: true }) as string[];

    return (
        <div className="caffa-explainer">
            <div className="caffa-explainer__header">
                <Link to="/knowledge-graph" className="caffa-explainer__back">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
                    </svg>
                    {t('caffa.explainer.backToGraph')}
                </Link>
                <h1 className="caffa-explainer__title">{t('caffa.explainer.title')}</h1>
                <p className="caffa-explainer__subtitle">{t('caffa.explainer.subtitle')}</p>
            </div>

            <section className="caffa-explainer__section">
                <h2 className="caffa-explainer__section-title">{t('caffa.explainer.whatIsTitle')}</h2>
                <p className="caffa-explainer__body">{t('caffa.explainer.whatIsBody')}</p>
            </section>

            <section className="caffa-explainer__section">
                <h2 className="caffa-explainer__section-title">{t('caffa.explainer.dimsTitle')}</h2>
                <div className="caffa-explainer__dim-grid">
                    {DIMENSIONS.map((key) => (
                        <article className={`caffa-explainer__dim caffa-explainer__dim--${key}`} key={key}>
                            <h3 className="caffa-explainer__dim-label">
                                {t(`caffa.explainer.dims.${key}.label`)}
                            </h3>
                            <p className="caffa-explainer__dim-meaning">
                                {t(`caffa.explainer.dims.${key}.meaning`)}
                            </p>
                            <div className="caffa-explainer__dim-block">
                                <span className="caffa-explainer__dim-kicker">e.g.</span>
                                <p>{t(`caffa.explainer.dims.${key}.examples`)}</p>
                            </div>
                            <div className="caffa-explainer__dim-block caffa-explainer__dim-block--tip">
                                <span className="caffa-explainer__dim-kicker">↗</span>
                                <p>{t(`caffa.explainer.dims.${key}.howToImprove`)}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className="caffa-explainer__section">
                <h2 className="caffa-explainer__section-title">{t('caffa.explainer.howToUseTitle')}</h2>
                <p className="caffa-explainer__body">{t('caffa.explainer.howToUseBody')}</p>
                {Array.isArray(combos) && combos.length > 0 && (
                    <ul className="caffa-explainer__combos">
                        {combos.map((c, i) => (
                            <li key={i}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                                <span>{c}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            <section className="caffa-explainer__row">
                <div className="caffa-explainer__card">
                    <h2 className="caffa-explainer__card-title">{t('caffa.explainer.cefrTitle')}</h2>
                    <p className="caffa-explainer__body">{t('caffa.explainer.cefrBody')}</p>
                </div>
                <div className="caffa-explainer__card">
                    <h2 className="caffa-explainer__card-title">{t('caffa.explainer.stabilityTitle')}</h2>
                    <p className="caffa-explainer__body">{t('caffa.explainer.stabilityBody')}</p>
                </div>
            </section>

            <section className="caffa-explainer__section">
                <h2 className="caffa-explainer__section-title">{t('caffa.explainer.tipsTitle')}</h2>
                {Array.isArray(tips) && tips.length > 0 && (
                    <ul className="caffa-explainer__tips">
                        {tips.map((tip, i) => (
                            <li key={i}>
                                <span className="caffa-explainer__tip-index">{i + 1}</span>
                                <span>{tip}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            <div className="caffa-explainer__footer-cta">
                <Link to="/writing" className="caffa-explainer__cta caffa-explainer__cta--primary">
                    {t('caffa.explainer.ctaStart')}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </Link>
                <Link to="/knowledge-graph" className="caffa-explainer__cta caffa-explainer__cta--ghost">
                    {t('caffa.explainer.ctaBackToGraph')}
                </Link>
            </div>
        </div>
    );
};

export default CaffaExplainerPage;
